import { render, staticRenderFns } from "./LiefengContent.vue?vue&type=template&id=2a1a3738&scoped=true&"
import script from "./LiefengContent.vue?vue&type=script&lang=js&"
export * from "./LiefengContent.vue?vue&type=script&lang=js&"
import style0 from "./LiefengContent.vue?vue&type=style&index=0&id=2a1a3738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a3738",
  null
  
)

export default component.exports